import { KTypeParameterBase70dfo08xyjmg as KTypeParameterBase } from '../../KTypeParameterBase.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KTypeParameterImplClass;
function KTypeParameterImpl() {
  if (KTypeParameterImplClass === VOID) {
    class $ extends KTypeParameterBase() {
      constructor(name, upperBounds, variance, isReified, containerFqName) {
        super();
        this.mf_1 = name;
        this.nf_1 = upperBounds;
        this.of_1 = variance;
        this.pf_1 = isReified;
        this.qf_1 = containerFqName;
      }
      h1() {
        return this.mf_1;
      }
      u1() {
        return this.of_1;
      }
      t1() {
        return this.qf_1;
      }
    }
    initMetadataForClass($, 'KTypeParameterImpl');
    KTypeParameterImplClass = $;
  }
  return KTypeParameterImplClass;
}
//region block: exports
export {
  KTypeParameterImpl as KTypeParameterImpl2de0szhlrzcmf,
};
//endregion

//# sourceMappingURL=KTypeParameterImpl.mjs.map
